/**
 * Text Type enum
 *
 * Defines the different types of text entities.
 * This enum corresponds to the backend TextType enum.
 */
export enum TextType {
  End = 'End',
  Beginning = 'Beginning',
  Finale = 'Finale'
}
